/*
from : http://en.wikipedia.org/wiki/Mersenne_twister
*/
let MT;
let index;
class prng {
  constructor() {
    this.setSeed(1);
  }

  setSeed(seed) {
    // Create a length 624 arrays to store the state of the generator
    MT = new Uint32Array(624);
    index = 0;
    MT[0] = seed;
    for (let i = 1; i < 624; i++) {
      MT[i] = 1812433253 * (MT[i - 1] ^ ((MT[i - 1] >> 30) + i));
    }
  }

  extractNumber() {
    if (index === 0) {
      this.generateNumbers();
    }

    let y = MT[index];
    y = y ^ (y >> 11);
    y = y ^ ((y << 7) & 2636928640);
    y = y ^ ((y << 15) & 4022730752);
    y = y ^ (y >> 18);

    index = (index + 1) % 624;
    return y;
  }

  generateNumbers() {
    for (let i = 0; i < 624; i++) {
      const y = (MT[i] & 0x80000000) + (MT[(i + 1) % 624] & 0x7fffffff);
      MT[i] = MT[(i + 397) % 624] ^ (y >> 1);
      if (y % 2 !== 0) {
        MT[i] = MT[i] ^ 2567483615;
      }
    }
  }

  random() {
    return this.extractNumber() / 0x7fffffff;
  }
}
export const PRNG = new prng();

class Scroll {
  constructor() {
    this._x = 0;
    this._y = 0;
  }
  set y(y) {
    this._y = y;
  }
  get y() {
    return this._y;
  }
  set x(x) {
    this._x = x;
  }
  get x() {
    return this._x;
  }
}

export const scroll = new Scroll();

// gets the FIFE URL of a list of asset ids (GAC ids)

export async function assetIDsToImageURLS(assetsList) {
  if (assetsList.length == 0) return {};
  const OG_DATA = {
    method: "POST",
    body: JSON.stringify({
      images: assetsList,
    }),
    cache: "no-cache",
    headers: new Headers({
      "content-type": "application/json",
    }),
  };
  return await fetch("./ogMultiple/", OG_DATA)
    .then((data) => {
      return data.json();
    })
    .then((json) => {
      const imagesDict = {};
      json["items"].forEach((image) => {
        imagesDict[image.id] = image.image.url;
      });
      return imagesDict;
    });
}

// determines which images are currently displayed on screen

// check if an image is in the viewport

function isInViewport(el) {
  const ww = window.innerWidth || document.documentElement.clientWidth;
  const wh = window.innerHeight || document.documentElement.clientHeight;
  const rect = el.getBoundingClientRect();
  if (rect.height > wh) return true;
  return (
    rect.top >= 0 && rect.left >= 0 && rect.bottom <= wh && rect.right <= ww
  );
}

// check if a n image is fully outside the viewport

function isFullyOutsideViewport(el) {
  const rect = el.getBoundingClientRect();
  return rect.bottom < 0 || rect.top > window.innerHeight;
}

// classify the images

export function checkImageInViewport(query = ".wrapper .imagesWrapper") {
  const result = { inside: [], partial: [], outside: [] };
  const images = document.querySelectorAll(query);
  images.forEach((image, index) => {
    if (isInViewport(image)) {
      result.inside.push(image);
    } else if (isFullyOutsideViewport(image)) {
      result.outside.push(image);
    } else {
      result.partial.push(image);
    }
  });
  return result;
}

// loads and returns a JSON
export async function loadJson(url) {
  return fetch(url).then((response) => response.json());
}
export function isMobileLayout() {
  // Tachyons breakpoints used for the css
  // @media screen and (min-width: 30em)
  const notSmallRule = "(min-width: 30em)";
  const isMobile = !window.matchMedia(notSmallRule).matches;
  return isMobile;
}

// check if scrolling position in the page is at 80% of the bottom
export function isScrollingToBottom() {
  // prevent infinite scroll to trigger while preloading stuff
  if (
    document.querySelector(".loader").classList.contains("hidden") === false
  ) {
    // console.log("nope!");
    return false;
  }
  const scrollPosition = window.scrollY;
  const bodyHeight = document.documentElement.scrollHeight - window.innerHeight;
  return scrollPosition / bodyHeight > 0.8;
}

export function scrollTo(top = 0, iOS = false) {
  if (iOS) {
    window.scrollTo(0, top);
  } else {
    window.scrollTo({ top: top, behavior: "smooth" });
  }
}

export function capitalizeString(str) {
  return str
    .trim()
    .split(" ")
    .map((s) => {
      const a = s.split("");
      a[0] = a[0].toUpperCase();
      return a.join("");
    })
    .join(" ");
}
